import React from "react";
import PropTypes from "prop-types";
import MessageContainer from "../MessageContainer";
import { ReactComponent as DocumentSvg } from "../../../../assets/chat/nda-document.svg";
import Button from "../../Button";

const _prefix = "chat-tendering__quotation-sent";

const QuotationSent = ({ quotationId }) => {
  const handleViewClick = () => {};

  return (
    <MessageContainer alignment={"center"}>
      <div className={_prefix}>
        <span>Quotation has been sent</span>
        <Button
          label={"Download Quotation"}
          size="small"
          onClick={handleViewClick}
        />
      </div>
    </MessageContainer>
  );
};

QuotationSent.propTypes = {};

export default QuotationSent;
